import axios from 'axios';

import {
    SEND_CONTACT,
    CHRISTMAS_BOOKING,
    GET_ERRORS,
    SET_LOADING,
    CLEAR_ERRORS,
    GET_TOURISTS_TERMS
} from './types';

import { API_ENDPOINT } from '../config/constants';

export const sendContactMessage = data => dispatch => {
    axios.post(API_ENDPOINT+'/contact', data)
        .then(res => {
            dispatch({
                type: SEND_CONTACT,
                payload: res.data
            })
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const sendChristmasForm = bookingData => dispatch => {
    axios.post(API_ENDPOINT+'/booking/route/subscribe', bookingData)
        .then(res => {
            dispatch({
                type: CHRISTMAS_BOOKING,
                payload: res.data
            })
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const setLoading = () => {
    return {
        type: SET_LOADING
    }
};

export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS
    }
};

export const getTouristsTerms = data => dispatch => {
    axios.get(API_ENDPOINT+'/terms/tourists', data)
        .then(res => {
            dispatch({
                type: GET_TOURISTS_TERMS,
                payload: res.data.content
            });
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};


// WEBPACK FOOTER //
// ./src/actions/commonActions.js